import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '../icon-prop-types';

export const AppStarRatingIcon = ({ fill = 'white' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            data-testid="app-star-rating-svg"
            width="88"
            height="16"
            viewBox="0 0 88 12"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <path
                    id="0trfkqh50a"
                    d="m8 12-4.702 2.472.898-5.236L.392 5.528l5.257-.764L8 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236z"
                />
            </defs>
            <g fill="none" fillRule="evenodd">
                <path
                    className={fillStyles}
                    d="m8 12-4.702 2.472.898-5.236L.392 5.528l5.257-.764L8 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236zM26 12l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L26 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236zM44 12l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L44 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236zM62 12l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L62 0l2.351 4.764 5.257.764-3.804 3.708.898 5.236z"
                />
                <g transform="translate(72)">
                    <mask id="6mr67sgpdb" fill="#fff">
                        <use href="#0trfkqh50a" />
                    </mask>
                    <use fillOpacity=".5" className={fillStyles} href="#0trfkqh50a" />
                    <path className={fillStyles} mask="url(#6mr67sgpdb)" d="M1-3h7v19H1z" />
                </g>
            </g>
        </svg>
    );
};
